module.exports = __webpack_public_path__ + "img/tema3.f28d76f5.svg";